// Bağlantı hatası durumu: timeout/network hatalarında kullanıcıya tek yerden mesaj
import { create } from 'zustand';

interface ConnectionState {
    message: string | null;
    setConnectionError: (message: string | null) => void;
    clearConnectionError: () => void;
}

export const useConnectionStore = create<ConnectionState>((set) => ({
    message: null,
    setConnectionError: (message) => set({ message }),
    clearConnectionError: () => set({ message: null }),
}));
